// @ts-nocheck
import ListItem from 'js/components/ListItem/ListItem'
import cx from 'js/lib/helpers/cx'

import styles from './Link.module.css'

const Link = ({ $size, $isInverted, className, style, ...rest }) => (
    <ListItem
        {...rest}
        $size={$size}
        className={cx(
            styles.link,
            $size === 'small' && styles.sizeSmall,
            $size === 'normal' && styles.sizeNormal,
            className,
        )}
        style={{
            ...style,
            ...($isInverted && { '--arrow-transform': 'scaleY(-1)' }),
        }}
    />
)

export default Link
